var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconX = function SvgIconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.447 0H.985l7.792 10.797L.912 19.5h2.426l6.515-7.211 5.205 7.211h6.462L13.447 8.312 20.957 0H18.53L12.37 6.82zm8.707 17.822L4.342 1.735h1.994l11.812 16.087z",
    clipRule: "evenodd"
  })));
};
export { SvgIconX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjQ0NzQ3IDBIMC45ODQ5NUw4Ljc3NjU0IDEwLjc5NjVMMC45MTIxMDkgMTkuNUgzLjMzNzU2TDkuODUzMzggMTIuMjg4NkwxNS4wNTc4IDE5LjVIMjEuNTIwM0wxMy40NDY1IDguMzEyMDNMMjAuOTU2NyAwSDE4LjUzMTRMMTIuMzY5MiA2LjgxOTk1TDcuNDQ3NDcgMFpNMTYuMTU0IDE3LjgyMTVMNC4zNDIxMiAxLjczNDdINi4zMzY0MkwxOC4xNDgzIDE3LjgyMTVIMTYuMTU0WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";